import { Component } from '@angular/core';
import { IcdCodeListComponent } from '../icd-code-list/icd-code-list';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';

@Component({
  selector: 'app-icd10-view',
  imports: [IcdCodeListComponent],
  templateUrl: './icd10-view.html',
  styleUrl: './icd10-view.scss',
})
export class Icd10ViewComponent {
  readonly codeType = IcdCodeType.Icd10;
}
